<template>
  <div class="riderHome">
    <van-row class="padding10 h-header disappearHead" id="boxFixed" :class="{'is_fixed' : isFixed}">
      <van-col span="12">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/logo_white.png" style="width:60%;">
      </van-col>
      <van-col span="12" class="text-right" @click="navShow">
        <span style="color:#fff;">菜单</span> <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/menu_rec.png" style="width:10%">
      </van-col>
    </van-row>
<!--    banner图部分-->
    <van-row>
      <van-col span="24">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/banner.png" class="width100 float-left">
      </van-col>
    </van-row>
<!--    骑士圈-->
    <van-row style="background: #f3f3f3;padding-bottom:50px;">
      <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/circle.png" style="height:23px;margin:10% 0 5% 5%;" class="animate__animated animate__bounceInUp">
      <div class="width100 float-left text-center">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/phone.png" class="width100 animate__animated animate__fadeInUp">
        <span class="text-gray text-xxs width100 float-left margin-top-5 animate__animated animate__backInUp" ref="one">
          免费下载注册即可畅所欲言 实时分享生活中的精彩瞬间
        </span>
        <span class="text-gray text-xxs width100 float-left margin-top-5 animate__animated animate__backInUp">
          与全国骑士伙伴们一起吐槽不公、分享精彩瞬间、记录生活点滴
        </span>
      </div>
    </van-row>
<!--    骑士服务-->
    <van-row class="bg-deepBlue">
      <van-col span="24">
        <span class="text-xl text-white float-left" style="margin:10% 0 2% 5%;">
          骑士服务
        </span>
          <span class="text-xxs text-white float-left" style="width:90%;margin:0 0 5% 5%;">
          为广大骑士们提供换电救援、法律咨询、行业资讯、二手市场、兼职机会等专属服务。
        </span>
      </van-col>
    </van-row>
    <van-row type="flex" justify="space-around" class="bg-deepBlue padding-bottom-50" >
      <van-col span="11" class='animate__animated animate__fadeInUp animate__faster' v-show="oneShow">
        <div class="serviceItem">
          <div class="serviceItemCenter">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/service1.png">
            <span>换电救援</span>
          </div>
        </div>
      </van-col>
      <van-col span="11" class='animate__animated animate__fadeInUp animate__faster' v-show="oneShow">
        <div class="serviceItem">
          <div class="serviceItemCenter">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/service2.png">
            <span>法律咨询</span>
          </div>
        </div>
      </van-col>
      <van-col span="11" class='animate__animated animate__fadeInUp ' v-show="oneShow">
        <div class="serviceItem">
          <div class="serviceItemCenter">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/service3.png">
            <span>行业资讯</span>
          </div>
        </div>
      </van-col>
      <van-col span="11" class='animate__animated animate__fadeInUp ' v-show="oneShow">
        <div class="serviceItem">
          <div class="serviceItemCenter">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/service4.png">
            <span>二手市场</span>
          </div>
        </div>
      </van-col>
      <van-col span="11" class='animate__animated animate__fadeInUp animate__slow' v-show="oneShow">
        <div class="serviceItem">
          <div class="serviceItemCenter">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/service5.png">
            <span>兼职机会</span>
          </div>
        </div>
      </van-col>
      <van-col span="11" class='animate__animated animate__fadeInUp animate__slow' v-show="oneShow">
        <div class="serviceItem" ref="three">
          <div class="serviceItemCenter">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/service6.png">
            <span>更多服务</span>
          </div>
        </div>
      </van-col>
    </van-row>
<!--    订单服务-->
    <van-row class="bg-grayWhite padding-bottom-30">
      <van-col span="24">
        <span class="text-xl text-grey float-left" style="margin:10% 0 2% 5%;" ref="four">
          订单服务
        </span>
        <span class="text-xxs text-grey float-left" style="width:90%;margin:0 0 5% 5%;">
          汇集同城配送、服务订单，通过认证以后即可自由兼职。
        </span>
      </van-col>
      <van-col span="24" style="padding:0 3%;" v-show="threeShow">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/cellphones.png" style="width:47%;" class="animate__animated animate__fadeInLeft">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/riders.png" style="width:52%;" class="float-right animate__animated animate__fadeInRight">
      </van-col>
      <van-col span="24" style="margin:3%;">
        <span class="text-xs text-gray">时间相同，订单相同，等级不同，收益不同。</span>
      </van-col>
      <van-col span="6">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/level1.png" v-show="fourShow" class="animate__animated animate__fadeIn animate__slower width100">
      </van-col>
      <van-col span="6">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/level2.png" v-show="fourShow" class="animate__animated animate__fadeIn animate__slower width100">
      </van-col>
      <van-col span="6">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/level3.png" v-show="fourShow" class="animate__animated animate__fadeIn animate__slower width100">
      </van-col>
      <van-col span="6">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/level4.png" v-show="fourShow" class="animate__animated animate__fadeIn animate__slower width100">
      </van-col>
    </van-row>
    <van-row class="bg-deepBlue padding-bottom-20">
      <van-col span="24">
        <span class="text-xl text-white float-left" style="margin:10% 0 2% 5%;">
          认证流程
        </span>
      </van-col>
      <van-col span="24">
        <swiper class="swiper" :options="swiperOption">
          <swiper-slide class="riderSwiper">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/process01.png" style="width:70%;margin-left:15%;">
            <span class="riderSwiperBold">01</span>
            <span class="riderSwiperBold">下载骑士端APP</span>
            <span>扫描二维码或应用</span>
            <span>市场下载APP</span>
          </swiper-slide>
          <swiper-slide class="riderSwiper">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/process02.png" style="width:70%;margin-left:15%;">
            <span class="riderSwiperBold">02</span>
            <span class="riderSwiperBold">注册骑士账号</span>
            <span>免费注册即可</span>
            <span>享受骑士圈及骑士服务</span>
          </swiper-slide>
          <swiper-slide class="riderSwiper">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/process03.png" style="width:70%;margin-left:15%;">
            <span class="riderSwiperBold">03</span>
            <span class="riderSwiperBold">签约成为骑士</span>
            <span>APP内点击认证，提交资料审核</span>
            <span>市场下载APP</span>
          </swiper-slide>
          <swiper-slide class="riderSwiper">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/process04.png" style="width:70%;margin-left:15%;">
            <span class="riderSwiperBold">04</span>
            <span class="riderSwiperBold">上岗开工</span>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </van-col>
    </van-row>
<!--    底部-->
    <van-row class="riderFooter">
      <van-col span="24">
        <ul class="foot-nav text-df-">
          <li @click="goToUrl('/')">首页</li>
          <li @click="goToUrl('/join')">城市合作</li>
          <li @click="goToUrl('/news')">365头条</li>
          <li @click="goToUrl('/brand')">品牌实力</li>
          <li @click="goToUrl('/riderHome')">骑士之家</li>
        </ul>
      </van-col>
      <van-col span="24" class="text-df- margin-top-20" style="color:#E7E7E7;">
        客户端下载
      </van-col>
      <van-col>
        <ul class="footBtnGroup">
          <li>
            <span>客户、商家端APP下载</span>
          </li>
          <li>
            <span>骑士端APP下载</span>
          </li>
        </ul>
      </van-col>
      <van-col span="24" class="footInfo" style="margin-top:50px;">
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/riderHome/logo.png" style="height:20px;">
      </van-col>
      <van-col span="24" class="footInfo">
        客服热线：17669726588
      </van-col>
      <van-col span="24" class="footInfo">
        ©2014-2021 青岛众业网络科技有限公司
      </van-col>
      <van-col span="24" class="footInfo">
        备案号：辽B2-20150082
      </van-col>
    </van-row>
    <!--        导航弹出层-->
    <van-popup v-model="navModal" position="right" :style="{ width: '100%',height:'100%' }">
      <navModal @closeNavModal="closeNavModal"></navModal>
    </van-popup>

  </div>
</template>

<script>
  import navModal from '../components/common/nav';
  export default {
    name: '',
    data () {
      return {
        navModal:false,
        offsetTop:0,
        isFixed: true,
        oneShow: false,
        twoShow: false,
        threeShow: false,
        fourShow: false,
        fiveShow: false,
        sixShow: false,
        sevenShow: false,
        swiperOption: {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    },
    components:{navModal},
    created(){
    },
    mounted(){
      // 监听高度
      window.addEventListener('scroll',this.initHeight);
      window.addEventListener('scroll', this.handleScroll);
      this.$nextTick( () => {
        this.offsetTop = document.querySelector('#boxFixed').offsetTop;
      })
    },
    methods:{
      // 监听高度
      handleScroll () {
        // 实现当滚动到指定位置，触发动画
        // let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
        // this.gdjz('earth', 'earth animated bounceInDown', 50)
        let _this = this
        let refArray = [
          {ref: 'one', show: 'oneShow'},
          {ref: 'two', show: 'twoShow'},
          {ref: 'three', show: 'threeShow'},
          {ref: 'four', show: 'fourShow'},
          {ref: 'five', show: 'fiveShow'},
          {ref: 'six', show: 'sixShow'},
          {ref: 'seven', show: 'sevenShow'}
        ]
        refArray.forEach((r) => {
          _this.$gdjz(r.ref, 200, (value) => {
            if(value===1){
              _this[r.show] = true
            }
            if(value===2){
              _this[r.show] = false
            }
          })
        })
      },
      // 页面跳转
      goToUrl(url){
          this.$router.push(url);
      },
      initHeight () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        this.isFixed = scrollTop > this.offsetTop ? false : true;
      },
      // 导航展示
      navShow(){
        this.navModal = true;
      },
      // 关闭导航模块
      closeNavModal(){
        this.navModal = false;
      }
    }
  }
</script>
<style lang="less">

</style>
